import * as React from 'react';
import { trackRemoveAllConfirm } from './tracking';
import { removeAll } from '../../../actions/favoriteEntities';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedProducts } from '../../../selectors/selected';
import { selectEntityTypeText } from '../../../selectors/filters/selectEntityTypeText';
import { getConfirmText } from '../../../utils/remove';
import { ModalConfirm } from '../../../components/ModalConfirm';
import { ModalFooter } from '../../../components/MassActions/remove/ModalFooter';

interface IProps {
  onClose(): void;
}

export function ModalConfirmRemoveAllContainer({ onClose }: IProps) {
  const dispatch = useDispatch();
  const selectedProducts = useSelector(selectSelectedProducts);
  const entityType = useSelector(selectEntityTypeText);

  const handleConfirm = () => {
    trackRemoveAllConfirm(selectedProducts);
    dispatch(removeAll());
    onClose();
  };

  return (
    <ModalConfirm
      text={getConfirmText(entityType)}
      footer={<ModalFooter onConfirm={handleConfirm} onCancel={onClose} />}
      onClose={onClose}
      isVisible={true}
    />
  );
}
